import React from "react";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { CardFooter, Button } from "reactstrap";
import { ReactComponent as BackIcon } from "../../../../../assets/utils/images/svgs/arrow-left.svg";
import { ReactComponent as AddIcon } from "../../../../../assets/utils/images/svgs/addBlue.svg";
import { useInstellingen } from "./Context/InstellingenContext";

export default function Footer() {
	const { filterCommunity, setFilterCommunity, adminCommunityList} =
		useGebruikerContext();
	const { setContractModal } = useInstellingen();
	return (
		<div className="chat-layout-footer py-5">
			<CardFooter className="chat-layout-footer__inner gebruikers-footer">
				<div className="d-flex gap-3 justify-conter-end w-100">
					<select
						className={`form-select`}
						  style={{ width: "20px" }}
						value={filterCommunity[0]?.iCommunityId}
						onChange={(e) => {
							setFilterCommunity(
								adminCommunityList.filter(
									(item) => item?.iCommunityId === Number(e.target.value)
								)
							);
						}}
					>
						<option value={""} disabled>
							Alle besturen
						</option>
						{adminCommunityList.map((item) => {
							return (
								<option value={item.iCommunityId} key={item.iCommunityId}>
									{item.vCommunityName}
								</option>
							);
						})}
					</select>
					<Button
						outline
						className="btn-outline-primary-blue d-flex justify-content-center align-items-center gap-2"
						onClick={() => setContractModal({ type: "add", state: true })}
						type="button"
						color="primary"
					>
						Contract <AddIcon />
					</Button>
					<Button
						outline
						className="btn-outline-primary-blue ms-auto"
						// onClick={() => {
						// 	setActiveTab(userTabs.Algemeen)
						// }}
						type="button"
						color="primary"
					>
						<BackIcon />
					</Button>
				</div>
			</CardFooter>
		</div>
	);
}
